import { useCallback, useEffect, useState } from "react";
import { Box, Checkbox, Tooltip } from "@mui/material";
import { useEditorContext } from "features/editor/context/editor";
import { SimilarTranslationInFile } from "features/editor/components/panels/SimilarTranslationInFile";
import { SimilarTranslationInProject } from "features/editor/components/panels/SimilarTranslationInProject";
import { getActiveItemTextarea } from "features/editor/utils/utils";

import { miniBarStyle, miniBarPosStyle, itemsStyle } from "./styles";

export const SimilarTranslation = () => {
  const [searchWholeProject, setSearchWholeProject] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { activeItemIndex } = useEditorContext();

  const onCopyClick = useCallback(
    (text: string) => {
      const activeItemHtml: HTMLElement = getActiveItemTextarea();

      if (!activeItemHtml) {
        return;
      }
      activeItemHtml.dispatchEvent(
        new CustomEvent("setTranslationValue", {
          detail: {
            value: text,
          },
        }),
      );
    },
    [activeItemIndex],
  );

  // Searching whole project
  const onSearchWholeProjectChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchWholeProject(event.target.checked);
  }, []);

  useEffect(() => {
    setSearchWholeProject(false);
  }, [activeItemIndex]);

  return (
    <>
      <Box sx={miniBarPosStyle}>
        <Box sx={miniBarStyle}>
          <Tooltip title="Search whole project">
            <Checkbox
              checked={searchWholeProject}
              onChange={onSearchWholeProjectChange}
              inputProps={{ "aria-label": "controlled" }}
              disabled={isLoading}
            />
          </Tooltip>
        </Box>
      </Box>
      <Box sx={itemsStyle}>
        {searchWholeProject ? (
          <SimilarTranslationInProject onCopyClick={onCopyClick} isLoading={isLoading} setIsLoading={setIsLoading} />
        ) : (
          <SimilarTranslationInFile onCopyClick={onCopyClick} isLoading={isLoading} setIsLoading={setIsLoading} />
        )}
      </Box>
    </>
  );
};
